import React from "react";
import { serializeToReact } from "./serializeToReact";
import { LexContentType } from "@/types/common";

interface LexicalRichTextProps {
  contentV2: LexContentType;
}

export const LexicalRichText = ({ contentV2 }: LexicalRichTextProps) => {
  if (!contentV2) {
    return null;
  }

  return <div>{serializeToReact(contentV2)}</div>;
};
